/* eslint-disable no-bitwise */
export const luma = (hexRgb) => {
  const c = hexRgb.substring(1); // strip #
  const rgb = parseInt(c, 16); // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff; // extract red
  const g = (rgb >> 8) & 0xff; // extract green
  const b = (rgb >> 0) & 0xff; // extract blue

  return 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
};

export const labelColor = (hexRgb) => {
  if (hexRgb === undefined || hexRgb === null) {
    return '#ff0000';
  }
  const l = luma(hexRgb);

  if (l > 170 || l === 0) {
    return '#000000';
  }

  return '#ffffff';
};
